import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppFooterModule, AppHeaderModule, AppSidebarModule } from '@coreui/angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		RouterModule,
		AppHeaderModule,
		BsDropdownModule,
		AppSidebarModule,
		PerfectScrollbarModule,
		AppFooterModule,
	],
	exports: [
		CommonModule,
		RouterModule,
		AppHeaderModule,
		BsDropdownModule,
		AppSidebarModule,
		PerfectScrollbarModule,
		AppFooterModule,
	],
})
export class LayoutModule {}
